import React, { useEffect, useState } from "react";
import Step01Start from "./steps/Step_01_Start";
import Step_02_Select_Project from "./steps/Step_02_Select_Project";
import Step_04_material from "./steps/Step_04_material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Step_03_designVibe from "./steps/Step_03_SelectImage";
import Step03_SelectImage from "./steps/Step_03_SelectImage";
import { BRANDS_LIST } from "../../../../utils/helpers";

const MainSidebar = ({
  designData,
  setDesignData,
  possibleOptions,
  isOpen,
  filters,
  setFilters,
  handleSaveMaterial,
  isPublicView,
  SetDesignDataForExistingMaterials,
  newFilter,
  setNewFilter,
  state,
  selectedProjectImage,
  setSelectedProjectImage,
  step,
  setStep,
  areas,
  setAreas,
  setAiRecommendations,
  aiRecommendations,
  aiImageLoading,
  setAiImageLoading,
  projectSearch,
  setProjectSearch,
}) => {
  const [searchParams] = useSearchParams();
  // console.log({ state, designData });
  const [selectedProjectImageUrl, setSelectedProjectImageUrl] = useState(null);
  const nav = useNavigate();

  let stateProjectImage = state?.selectedProjectImage;
  // console.log("STEP", step);

  return (
    <div className="h-full">
      {step == 1 && (
        <div className="h-full flex items-center">
          <Step01Start handleNextStep={() => setStep(2)} />
        </div>
      )}
      {step == 2 && (
        <div className="h-full overscroll-contain">
          <Step_02_Select_Project
            isOpen={isOpen}
            setSelectedProjectImageUrl={setSelectedProjectImageUrl}
            selectedProject={designData?.projectId}
            setSelectedProject={(id, name) => {
              setDesignData((p) => ({
                ...p,
                projectId: p?.projectId == id ? null : id,
                projectName: name,
              }));

              if (id != designData?.projectId && id != null) {
                setStep(3);
              }
            }}
            search={projectSearch}
            setSearch={setProjectSearch}
          />
        </div>
      )}
      {step == 3 && (
        <div className="h-full overflow-y-auto overscroll-contain">
          <Step03_SelectImage
            nextStep={() => {
              console.log({
                selectedProjectImage,
                stateProjectImage,
                state: state?.stateProjectImage,
              });
              if (selectedProjectImage != state?.selectedProjectImage) {
                stateProjectImage = null;
              }
              setStep(4);
            }}
            state={state}
            projectId={designData?.projectId}
            selectedProjectImage={selectedProjectImage}
            setSelectedProjectImage={(imgKey, imgUrl) => {
              setSelectedProjectImage((p) => (p == imgKey ? null : imgKey));
              setSelectedProjectImageUrl((p) =>
                (p || "").includes(imgKey) ? null : imgUrl,
              );
            }}
          />
        </div>
      )}
      {step == 4 && (
        <Step_04_material
          key={selectedProjectImage}
          materials={designData?.selectedMaterial}
          projectId={designData?.projectId}
          setDesignData={setDesignData}
          possibleOptions={possibleOptions}
          handleSaveMaterial={handleSaveMaterial}
          SetDesignDataForExistingMaterials={SetDesignDataForExistingMaterials}
          selectedProjectImage={selectedProjectImage}
          selectedProjectImageUrl={selectedProjectImageUrl}
          setSelectedProjectImage={setSelectedProjectImage}
          isPublicView={isPublicView}
          navigatePublicView={(obj) =>
            nav(
              `/public-view/${encodeURIComponent(designData?.projectName)}/${designData?.projectId}`,
              { state: { ...state, step, ...obj, designData } },
            )
          }
          state={state}
          filters={filters}
          setFilters={(zone, section, isEmptyArea) => {
            console.log("Filters changed", { zone, section });
            if (zone) {
              let brands = [];
              if (section) {
                brands = BRANDS_LIST.filter((b) => b.type == section).map(
                  (b) => b._id,
                );
                console.log({ section, BRANDS_LIST, brands });
              }

              setNewFilter((p) => ({
                ...p,
                zone: [zone],
                brands,
                types: [section],
              }));
            } else {
              setNewFilter((p) => ({
                ...p,
                zone: isEmptyArea ? [] : areas,
                brands: [],
                ...(isEmptyArea ? { types: [], type: [] } : {}),
              }));
            }
            setFilters({
              zone: zone ? [zone] : [],
              section: section ? [section] : [],
              material: [],
            });
          }}
          newFilter={newFilter}
          setNewFilter={setNewFilter}
          areas={areas}
          setAiRecommendations={setAiRecommendations}
          aiRecommendations={aiRecommendations}
          stateProjectImage={stateProjectImage}
          setAreas={(area) => {
            setAreas(area);
            setNewFilter((p) => ({
              ...p,
              zone: area,
            }));
          }}
          aiImageLoading={aiImageLoading}
          setAiImageLoading={setAiImageLoading}
        />
      )}
    </div>
  );
};

export default MainSidebar;
